import { useRef } from "react";
import { DateType, getDateMoment } from "../helpers/dateHelper";

/** Invalid visible edits must not erase the field's DST occurrence anchor. */
export function useLastValidDateTime(value: DateType, identity: string): DateType {
    const anchor = useRef<{ identity: string; value: DateType }>({ identity, value: null });
    if (anchor.current.identity !== identity) anchor.current = { identity, value: null };
    if (value === null) anchor.current.value = null;
    if (value !== null && getDateMoment(value).isValid())
        anchor.current.value = getDateMoment(value).valueOf();
    return anchor.current.value;
}
